import React, { useState, useEffect } from 'react';
import { apiClient } from '../../apiClient';

const StripeSettings = () => {
    const [settings, setSettings] = useState({
        invoice: {
            description: '',
            footer: ''
        }
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await apiClient.get('/v1/admin/system-settings/stripe');
                if (response.ok) {
                    const data = await response.json();
                    setSettings({
                        invoice: {
                            description: data.invoice?.description || '',
                            footer: data.invoice?.footer || ''
                        }
                    });
                } else {
                    setError('Stripe設定を取得できませんでした。');
                }
            } catch (error) {
                console.error("Error fetching stripe settings:", error);
                setError('Stripe設定を取得できませんでした。');
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage('');
        setError('');
        try {
            const response = await apiClient.post('/v1/admin/system-settings/stripe', settings);
            if (response.ok) {
                setMessage('Stripe設定を保存しました。');
            } else {
                setError('Stripe設定の保存に失敗しました。');
            }
        } catch (error) {
            console.error("Error saving stripe settings:", error);
            setError('Stripe設定の保存に失敗しました。');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="p-8 text-center text-gray-500">読み込み中...</div>;

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6">Stripe設定</h2>

            {message && (
                <div className="p-4 mb-4 rounded bg-green-100 text-green-700 border border-green-200">
                    {message}
                </div>
            )}
            
            {error && (
                <div className="p-4 mb-4 rounded bg-red-100 text-red-700 border border-red-200">
                    {error}
                </div>
            )}

            <div className="bg-white shadow rounded-lg p-6 max-w-2xl border border-gray-100">
                <form onSubmit={handleSave} className="space-y-6">
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-1">請求書メモ</label>
                        <textarea
                            value={settings.invoice.description}
                            onChange={(e) => setSettings({
                                ...settings,
                                invoice: { ...settings.invoice, description: e.target.value }
                            })}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-3 focus:ring-indigo-500 focus:border-indigo-500 min-h-[120px]"
                            placeholder="請求書上部に表示されるメモです。"
                            maxLength={5000}
                        />
                        <p className="mt-2 text-xs text-gray-500">
                            請求書上部に表示されるメモです。改行はそのまま反映されます。 (最大5000文字)
                        </p>
                    </div>

                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-1">請求書フッター</label>
                        <textarea
                            value={settings.invoice.footer}
                            onChange={(e) => setSettings({
                                ...settings,
                                invoice: { ...settings.invoice, footer: e.target.value }
                            })}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-3 focus:ring-indigo-500 focus:border-indigo-500 min-h-[120px]"
                            placeholder="請求書下部に表示されるメッセージです。"
                            maxLength={5000}
                        />
                        <p className="mt-2 text-xs text-gray-500">
                            請求書下部に表示されるメッセージです。改行はそのまま反映されます。 (最大5000文字)
                        </p>
                    </div>

                    <button
                        type="submit"
                        disabled={saving}
                        className="w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 disabled:bg-gray-400 font-bold transition-colors"
                    >
                        {saving ? '保存中...' : '保存'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default StripeSettings;
